import "./bibliography.css";
import { Controller as BaseController } from "@hotwired/stimulus";

export class Controller extends BaseController {
  static targets = [
    "copyIcon",
    "checkIcon",
    "button",
    "copyAllIcon",
    "checkAllIcon",
    "copyAllButton",
    "label",
  ];

  copy(event) {
    const button = event.currentTarget;
    const itemContent = button
      .closest("li")
      .querySelector(".Bibliography-item-copiable");
    if (!itemContent) return;

    const text = itemContent.innerText.trim();
    if (!text) return;

    navigator.clipboard.writeText(text).then(() => {
      this.showCopiedState(button);
      setTimeout(() => this.resetState(button), 2000);
    });
  }

  copyAll() {
    const contents = this.element.querySelectorAll(
      ".Bibliography-item-copiable"
    );
    const text = Array.from(contents)
      .map((el) => el.innerText.trim())
      .join("\n");

    if (!text) return;

    navigator.clipboard.writeText(text).then(() => {
      this.showCopiedAllState();
      setTimeout(() => this.resetAllState(), 2000);
    });
  }

  showCopiedState(button) {
    if (this.copyIconTarget && this.checkIconTarget) {
      this.copyIconTarget.style.display = "none";
      this.checkIconTarget.style.display = "flex";
    }
    button.classList.add("copied");
  }

  resetState(button) {
    if (this.copyIconTarget && this.checkIconTarget) {
      this.copyIconTarget.style.display = "flex";
      this.checkIconTarget.style.display = "none";
    }
    button.classList.remove("copied");
  }

  showCopiedAllState() {
    if (this.hasCopyAllIconTarget && this.hasCheckAllIconTarget) {
      this.copyAllIconTarget.style.display = "none";
      this.checkAllIconTarget.style.display = "flex";
    }

    if (this.hasCopyAllButtonTarget) {
      this.copyAllButtonTarget.classList.add(
        "Bibliography-clipboard-button--copied"
      );
    }

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = "Copié";
    }
  }

  resetAllState() {
    if (this.hasCopyAllIconTarget && this.hasCheckAllIconTarget) {
      this.copyAllIconTarget.style.display = "flex";
      this.checkAllIconTarget.style.display = "none";
    }

    if (this.hasCopyAllButtonTarget) {
      this.copyAllButtonTarget.classList.remove(
        "Bibliography-clipboard-button--copied"
      );
    }

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = "Tout copier";
    }
  }
}
